import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n';

const API_BASE = import.meta.env.VITE_API_BASE || 'https://clal-mobile-api.bawaya-2019.workers.dev/api';

export default function Login() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(t('login.logging_in'));

  useEffect(() => {
    // Auto-login without password
    const autoLogin = async () => {
      try {
        const response = await fetch(`${API_BASE}/auth/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: 'admin@clalmobile.co.il',
            password: 'admin123'
          })
        });

        const data = await response.json();

        if (data.accessToken) {
          localStorage.setItem('accessToken', data.accessToken);
          localStorage.setItem('token', data.accessToken);
          localStorage.setItem('user', JSON.stringify(data.user));
          setStatus(t('login.success'));
          setTimeout(() => navigate('/', { replace: true }), 500);
        } else {
          setStatus(t('login.failed'));
        }
      } catch (error) {
        console.error('Auto-login error:', error);
        setStatus(t('login.error'));
      }
    };

    autoLogin();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-white font-bold text-3xl">C</span>
          </div>
          <h1 className="text-2xl font-bold text-white">Clal CRM</h1>
          <p className="text-gray-400 mt-2">{t('login.subtitle')}</p>
        </div>

        <div className="card text-center py-8">
          <div className="w-12 h-12 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg text-gray-300">{status}</p>
        </div>
      </div>
    </div>
  );
}
